document.addEventSelectorListener("mouseover", "[data-multihover]", function(event, target) {
	let id = target.getAttribute("data-multihover");
	for (let element of document.querySelectorAll("[data-multihover='" + id + "']")) {
		element.classList.add("active");
	}
}, { passive: true });

document.addEventSelectorListener("mouseout", "[data-multihover]", function(event, target) {
	let id = target.getAttribute("data-multihover");
	for (let element of document.querySelectorAll("[data-multihover='" + id + "']")) {
		element.classList.remove("active");
	}
}, { passive: true });